import ky from "ky";

export default function isHTTPError(e: unknown): e is ky.HTTPError {
  return e instanceof ky.HTTPError;
}
